<template>
    <div class="content">
        <router-view v-slot="{ Component }">
            <transition-fade :duration="100"
                             mode="out-in">
                <component :is="Component" />
            </transition-fade>
        </router-view>
    </div>
</template>
<script setup lang="ts">
</script>
